export const windowRef = window;
export const documentRef = window.document;
